import React from 'react';
import { Check, Shield, Zap, Settings, Star, TrendingUp, CreditCard, Send, Lock, Store, ArrowRight, Globe } from 'lucide-react';
import { motion } from 'framer-motion';
const features = [{
  icon: Shield,
  title: 'Diseño Premium',
  desc: 'Mobile-first y optimizado'
}, {
  icon: Star,
  title: 'Credibilidad',
  desc: 'Reseñas y galería de proyectos'
}, {
  icon: TrendingUp,
  title: 'Crecimiento',
  desc: 'SEO Local y Google Business'
}];
export function PricingSection() {
  return <section id="servicios" className="py-24 bg-dark relative" data-id="element-286" data-mp="1s7snco3t6508">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-287" data-mp="1x9rqpxzjt1x6"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-288" data-mp="2uyubwquc746">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-289" data-mp="2x1uvapmdin5">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-290" data-mp="1hon33r8fbmvd">
            Todo Lo Que Necesitas. <br className="hidden md:block" data-id="element-291" data-mp="1cr4u60uep7nd" />
            <span className="text-gold" data-id="element-292" data-mp="17sacj286dp4u">Un Solo Pago.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-293" data-mp="25g2cu52j56gn">
          {/* Main Pricing Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-gradient-to-br from-dark-100 to-dark-200 rounded-3xl border-2 border-gold p-8 md:p-10 shadow-[0_0_40px_rgba(212,175,55,0.15)] relative overflow-hidden" data-id="element-294" data-mp="20fxvkctss7pd">
            <div className="absolute top-0 right-0 bg-gold text-dark font-bold px-6 py-2 rounded-bl-2xl text-sm uppercase tracking-wider z-10" data-id="element-295" data-mp="hj2vgtzs9zco">
              Oferta Principal
            </div>

            <div className="relative -mx-8 md:-mx-10 -mt-8 md:-mt-10 mb-8 rounded-t-3xl overflow-hidden" data-id="element-296" data-mp="7isinahnuty1">
              <img src="https://cdn.magicpatterns.com/uploads/joXRLUuV19avwWiRtVmmjh/heylloyd-image-1782678468852.png" alt="Ejemplo de website profesional para contratistas mostrado en una laptop" className="w-full h-64 md:h-72 object-cover object-[center_38%]" data-id="element-297" data-mp="chdn5m3y3zsa" />
              <div className="absolute inset-0 bg-gradient-to-t from-dark-100 via-dark-100/20 to-transparent" data-id="element-298" data-mp="3kwds8modhxkv"></div>
            </div>

            <div className="mb-8" data-id="element-299" data-mp="3bxa6faxtn42o">
              <h3 className="flex items-center gap-2 text-xl font-bold text-white mb-4" data-id="element-300" data-mp="3bz3dusg9dsbq">
                <Zap className="w-5 h-5 text-gold" data-id="element-301" data-mp="3fycb47aic8c1" />
                DEMO DE TU WEBSITE
              </h3>
              <div className="flex items-baseline mb-3" data-id="element-302" data-mp="2xbwe7iw84gs5">
                <span className="text-6xl font-extrabold text-gold" data-id="element-303" data-mp="2sca0l8chgyit">$25</span>
                <span className="text-gray-400 ml-2 font-medium" data-id="element-304" data-mp="2secy0dfyttxk">
                  por tu demo
                </span>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed" data-id="element-305" data-mp="31cf6fe213ouv">
                Si te gusta, pagas los{' '}
                <strong className="text-white" data-id="element-306" data-mp="3g8xljad92sz9">$225 restantes</strong> y lo
                lanzamos (total $250). Si no te gusta,{' '}
                <strong className="text-white" data-id="element-307" data-mp="3b8s04bxkq2pm">
                  solo se te cobra el demo
                </strong>
                . Y la verdad, estamos seguros de que te va a encantar.
              </p>
            </div>

            <div className="space-y-4 mb-8" data-id="element-308" data-mp="2v2mcbpenk79">
              {['Empieza con solo $25 — sin riesgo', 'Ves tu website real antes de pagar más', 'Si no te gusta, no pagas nada más', 'Sin contratos ni mensualidades'].map((text, i) => <div key={i} className="flex items-center gap-3" data-id="element-309" data-mp="lz619k855v0y" data-mpi={i}>
                  <div className="bg-gold/20 p-1 rounded-full shrink-0" data-id="element-310" data-mp="lxl9g2d7oq6s">
                    <Check className="w-4 h-4 text-gold" data-id="element-311" data-mp="qqxszy31a6so" />
                  </div>
                  <span className="text-white font-medium" data-id="element-312" data-mp="vofu52at7hq4">{text}</span>
                </div>)}
            </div>

            <a href="https://wa.me/447311754270?text=DEMO" target="_blank" rel="noopener noreferrer" className="block w-full py-4 text-center bg-gold hover:bg-gold-400 text-dark font-bold rounded-xl transition-colors" data-id="element-313" data-mp="3v6fec67dlzk0">
              QUIERO MI DEMO POR $25
            </a>

            {/* Payment methods */}
            <div className="mt-6 pt-6 border-t border-white/10" data-id="element-314" data-mp="1jea6zjv4p6ad">
              <div className="flex items-center justify-center gap-2 text-gray-400 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-315" data-mp="1odn36v7w3ppm">
                <Lock className="w-3.5 h-3.5 text-gold" data-id="element-316" data-mp="38uvzzn6x56ua" />
                Métodos de pago seguros
              </div>
              <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-317" data-mp="33xw23zk83ae9">
                <div className="flex items-center gap-2 bg-dark-300/60 border border-white/10 rounded-xl px-4 py-2.5" data-id="element-318" data-mp="2z52wzakue01n">
                  <Send className="w-4 h-4 text-gold" data-id="element-319" data-mp="2u717a6swv2h7" />
                  <span className="text-white font-semibold text-sm" data-id="element-320" data-mp="2q5zdw6lodkn5">
                    Zelle
                  </span>
                </div>
                <div className="flex items-center gap-2 bg-dark-300/60 border border-white/10 rounded-xl px-4 py-2.5" data-id="element-321" data-mp="2l5bgn36us7kh">
                  <CreditCard className="w-4 h-4 text-gold" data-id="element-322" data-mp="2g9csngpfsrkl" />
                  <span className="text-white font-semibold text-sm" data-id="element-323" data-mp="2b9zwg5coe85c">
                    Tarjeta
                  </span>
                  <span className="text-gray-500 text-xs" data-id="element-324" data-mp="ee2fj12fjcjf">vía Stripe</span>
                </div>
              </div>

              <p className="mt-5 flex items-start justify-center gap-2 text-[11px] leading-relaxed text-gray-500 text-center" data-id="element-325" data-mp="23xagh550vum3">
                <Globe className="w-3.5 h-3.5 text-gray-600 shrink-0 mt-px" data-id="element-326" data-mp="28oac872eo6n0" />
                <span data-id="element-327" data-mp="1tze7aivnb9qm">
                  El dominio está incluido por 1 año. Después del primer año se
                  renueva por separado con un costo anual.
                </span>
              </p>
            </div>
          </motion.div>

          {/* Features & Maintenance */}
          <div className="space-y-6" data-id="element-328" data-mp="2mlyzfljy3pv8">
            <div className="grid gap-4" data-id="element-329" data-mp="2rn4uhq12vp7x">
              {features.map((feat, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="bg-dark-100 p-5 rounded-2xl border border-white/5 flex items-center gap-4" data-id="element-330" data-mp="2dnmyaplgd9oj" data-mpi={i}>
                  <feat.icon className="w-8 h-8 text-gold shrink-0" data-id="element-331" data-mp="ttae7uy5cfp5" />
                  <div data-id="element-332" data-mp="18nordev14uvw">
                    <h4 className="text-white font-bold" data-id="element-333" data-mp="18lugktdh2j5j">{feat.title}</h4>
                    <p className="text-gray-400 text-sm" data-id="element-334" data-mp="13pn74qlvapiu">{feat.desc}</p>
                  </div>
                </motion.div>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="bg-dark-200 rounded-2xl border border-white/10 p-6 flex items-center justify-between" data-id="element-335" data-mp="b0ye7euytqi6">
              <div data-id="element-336" data-mp="32w01o0oyw23c">
                <div className="inline-flex items-center gap-2 text-gray-400 font-bold uppercase text-xs mb-1" data-id="element-337" data-mp="32wt973vr2vmj">
                  <Settings className="w-4 h-4" data-id="element-338" data-mp="37w5tbgv8lolf" /> Opcional
                </div>
                <h4 className="text-white font-bold" data-id="element-339" data-mp="3cto5dg4jwjxn">Mantenimiento</h4>
                <p className="text-gray-400 text-sm" data-id="element-340" data-mp="3cwk3p5kb9amm">
                  Actualizaciones y soporte
                </p>
              </div>
              <div className="text-right" data-id="element-341" data-mp="3lvnms9jh9q14">
                <div className="text-2xl font-bold text-white" data-id="element-342" data-mp="3lsrqepna39es">$30</div>
                <div className="text-xs text-gray-500" data-id="element-343" data-mp="3qsnuspzw12uv">/ mes</div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Other businesses note */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-10 bg-dark-100 border border-gold/20 rounded-2xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left" data-id="element-344" data-mp="4enntg2xsto6">
          <div className="flex items-center gap-4" data-id="element-345" data-mp="1owf1wsjvrpt9">
            <div className="shrink-0 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gold/15 text-gold" data-id="element-346" data-mp="1owyio5xso85p">
              <Store className="w-6 h-6" data-id="element-347" data-mp="1jzeuad7duf01" />
            </div>
            <div data-id="element-348" data-mp="2gmjhmdwp3oo5">
              <h4 className="text-white font-bold" data-id="element-349" data-mp="2gn30pxy30j3r">
                ¿Tienes otro tipo de negocio?
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-350" data-mp="2co3wygo36sdw">
                También creamos websites para cualquier negocio. Pregúntanos sin
                compromiso.
              </p>
            </div>
          </div>
          <a href="https://wa.me/447311754270?text=Hola,%20me%20interesa%20un%20website%20para%20mi%20negocio" target="_blank" rel="noopener noreferrer" className="shrink-0 inline-flex items-center gap-2 py-3 px-6 bg-gold/10 hover:bg-gold hover:text-dark text-gold font-bold rounded-xl border border-gold/30 transition-colors" data-id="element-351" data-mp="22udatiffmu1d">
            Pregúntanos
            <ArrowRight className="w-4 h-4" data-id="element-352" data-mp="1dw06a5e3ews4" />
          </a>
        </motion.div>
      </div>
    </section>;
}